import { render, staticRenderFns } from "./orderRecommended.vue?vue&type=template&id=45f046d6"
import script from "./orderRecommended.vue?vue&type=script&lang=js"
export * from "./orderRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f046d6')) {
      api.createRecord('45f046d6', component.options)
    } else {
      api.reload('45f046d6', component.options)
    }
    module.hot.accept("./orderRecommended.vue?vue&type=template&id=45f046d6", function () {
      api.rerender('45f046d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/reportModule/orderRecommended.vue"
export default component.exports